export default __webpack_public_path__ + "ee7651a44b6163153ccef5227a167793.svg";